// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"421":"2afa5843","845":"49513a7c","850":"da9fe32c"}[chunkId] + ".chunk.js";
};